import { useState } from 'react'
import './QuestionInput.css';


function QuestionInput({sendRequest, questionPrompt, setQuestionPrompt}) {

  const onSubmit = (e) => {
    e.preventDefault();
    sendRequest(questionPrompt);
    return false;
  }

  return (
    <div className="question-input">
      <form onSubmit={onSubmit}>
        <input onChange={ e => setQuestionPrompt(e.target.value) } type="text" placeholder="Ask me anything..." value={questionPrompt}></input>
        <button className="question-input-button" onClick={() => sendRequest(questionPrompt)} type="button">GO</button>
      </form>
    </div>
  );
}

export default QuestionInput;
